"use strict";

define('collection/base',['underscore', 'backbone', 'datakit/collection'], function (_, Backbone, Collection) {
  var Base = Collection.extend({
    ajaxTimeout: 450000,
    parse: function parse(resp) {
      if (resp.valid === false) {
        throw new Error(resp.error.message);
      }
      return resp.data;
    },
    mapById: function mapById(collection) {
      var models = [],
        myModels;
      if (collection instanceof Backbone.Collection) {
        models = collection.models;
      } else if (_.isArray(collection)) {
        models = collection;
      }
      myModels = _.map(models, function (model) {
        return this.get(model.id);
      }, this);
      return new this.constructor(myModels);
    },
    sync: function sync(method, collection, options) {
      options = options || {};
      options.timeout = this.ajaxTimeout;
      return Collection.prototype.sync.apply(this, arguments);
    }
  });
  return Base;
});

